import { Entity } from '@decahedron/entity';

export default class CarDamage extends Entity {
    public id: string = null;

    public name: string = null;

    public nl: string = null;

    public fr: string = null;

    public getNameInLangguage(language: string) {
        if (language === 'nl' && this.nl) {
            return this.nl;
        }
        if (language === 'fr' && this.fr) {
            return this.fr;
        }

        return this.name;
    }
}
